import React from 'react'
import { motion } from 'framer-motion'
import { Box, useMediaQuery } from '@material-ui/core'

const ContentModal = ({ children, onClose, color = '#00ffff', additionalButtons = null }) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        background: 'rgba(8, 8, 8, 0.99)',
        backdropFilter: 'blur(10px)',
        overflowX: 'hidden'
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: 0,
        }}
      >
        <Box style={{
          position: 'fixed',
          top: isMobile ? '0.5rem' : '1rem',
          right: isMobile ? '0.5rem' : '1rem',
          display: 'flex',
          gap: '1rem',
          zIndex: 10001
        }}>
          {/* Additional Buttons (rendered by parent component) */}
          {additionalButtons}

          {/* Go Back Button */}
          <Box
            onClick={onClose}
            style={{
              padding: isMobile ? '0.75rem 1.5rem' : '1rem 2rem',
              background: `linear-gradient(135deg, ${color}33 0%, ${color}1A 100%)`,
              border: `2px solid ${color}`,
              borderRadius: '8px',
              cursor: 'pointer',
              fontFamily: '"Orbitron", monospace',
              fontSize: isMobile ? '0.8rem' : '0.9rem',
              fontWeight: 'bold',
              color,
              textShadow: `0 0 10px ${color}`,
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)'
              e.currentTarget.style.boxShadow = `0 0 30px ${color}99`
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            ← GO BACK
          </Box>
        </Box>

        {children}
      </motion.div>
    </motion.div>
  )
}

export default ContentModal
